import React from 'react'
import Search from './Search'
import GreenCover from './GreenCover'

const SearchPage = () => {
  return (
    <>
    <Search/>
    <GreenCover/>
    </>
  )
}

export default SearchPage